import SpriteMenu  from './SpriteMenu';

export default SpriteMenu;
